import { ProgrammableSurfacesCommunication } from '../communication/ProgrammableSurfacesCommunication';
import { ProgrammableSurfacesEvents } from '../communication/types';
import { EntryPoint } from '../../src/entryPointConfig';

type DialogProperties = {
    entryPoint: EntryPoint;
    width: number;
    height: number;
};

export const OpenDialog = (dialogProperties: DialogProperties) => {
    // Calculate dynamic dimensions based on screen size
    const screenWidth = window.screen.availWidth || window.innerWidth;
    const screenHeight = window.screen.availHeight || window.innerHeight;

    const aspectRatio = dialogProperties.width / dialogProperties.height;

    // Calculate based on screen width (60% of available width)
    let dialogWidth = Math.min(screenWidth * 0.6, dialogProperties.width);
    let dialogHeight = dialogWidth / aspectRatio;

    // If calculated height exceeds screen bounds, recalculate based on height
    if (dialogHeight > screenHeight * 0.8) {
        dialogHeight = screenHeight * 0.8;
        dialogWidth = dialogHeight * aspectRatio;
    }

    // Apply minimum bounds while maintaining aspect ratio
    if (dialogWidth < 600) {
        dialogWidth = 600;
        dialogHeight = dialogWidth / aspectRatio;
    }

    const communication = ProgrammableSurfacesCommunication.getInstance();
    communication.sendEvent({
        eventType: ProgrammableSurfacesEvents.OpenDialog,
        payload: {
            entryPoint: dialogProperties.entryPoint,
            height: Math.round(dialogHeight),
            width: Math.round(dialogWidth)
        }
    });
};